import {ISeasonStats} from "modules/actions/stats";
import {createAction} from "redux-act";

export interface IPlayerStatsByEvent {
	best_round: number | null;
	eagles: number | null;
	birdies: number | null;
	pars: number | null;
	bogeys: number | null;
	double_bogeys: number | null;
	low_round: number | null;
	score: number | null;
	fantasy_points: number | null;
	owned_by?: number;
	date_start: string;
	position: {
		is_tie: boolean;
		position: number | string | null;
		missed_cut: boolean;
		position_desc: number | string | null;
	};
	triple_bogeys_or_worse: number | null;
}

export interface IPlayerEdgeScore {
	score: number | null;
	skill: number;
	consistency: number;
	risk: number;
	eventsUsed: number;
	unrated: boolean;
	lastEventId: number | null;
}

export interface IPlayer {
	id: number;
	firstName: string;
	lastName: string;
	country: string;
	edgeScore: IPlayerEdgeScore | null;
}

export interface IEventPlayer extends IPlayer {
	id: number;
	firstname: string;
	lastname: string;
	is_dpwt_member: boolean;
	dpwt_wins: number;
	stats: {
		form: string;
		last_year: Record<number, number>;
		positions: Record<
			number,
			{
				is_tie: boolean;
				position: number;
				position_desc: number;
				missed_cut: boolean;
			}
		>;
		avg_points: number;
		event_scores: Record<number, number>;
		total_points: number;
		owned_by: number;
	};
	world_rank: number;
	dpwt_rank: number;
	event_stats: {
		best_round: number | null;
		eagles: number | null;
		birdies: number | null;
		pars: number | null;
		bogeys: number | null;
		double_bogeys: number | null;
		score: number | null;
		triple_bogeys_or_worse: number | null;
		green_in_regulation: number | null;
	};
	event_round_scores: Record<number, Record<number, number>>;
	above_cut_off: boolean;
	missed_cut: boolean;
	country: string;
}

export interface IPlayerWithSeasonStats extends IEventPlayer {
	season_stats: ISeasonStats;
	edgeScore: IPlayerEdgeScore | null;
}

export interface ISetPlayersByEvent {
	players: IEventPlayer[];
	eventID: number;
}

export const requestAllPlayersJSON = createAction();
export const requestAllPlayersJSONSuccess = createAction<IPlayer[]>();
export const requestAllPlayersJSONFailed = createAction();

export const requestPlayersJSON = createAction<number>();
export const requestPlayersJSONSuccess = createAction<ISetPlayersByEvent>();
export const requestPlayersJSONFailed = createAction();

export interface ISetPlayerStatsByPlayerID {
	stats: Record<number, IPlayerStatsByEvent>;
	playerID: number;
}

export const requestPlayerStatsJSON = createAction<number>();
export const requestPlayerStatsJSONSuccess = createAction<ISetPlayerStatsByPlayerID>();
export const requestPlayerStatsJSONFailed = createAction();
